// extracted by mini-css-extract-plugin
export default {"propertyReadOnly":"JwMMd","value":"fU1q4","missingValue":"J9axc","icon":"MfCBz"};